import { useQuery } from '@tanstack/react-query';
import api from '~/api';
import { useClaim } from '~/features/claimReview/ClaimReviewProvider';
import { useStoreId } from '~/providers/StoreUserProvider';

export function useClaimLedgerSummary() {
  const claim = useClaim();
  const storeId = useStoreId();

  return useQuery({
    queryKey: ['claimLedger', storeId, claim.id],
    queryFn: () => api.store(storeId).claim(`${claim.id}`).ledger(),
    // the ledger card only renders for returns
    enabled: claim.claimType === 'Return',
  });
}
